"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@mui/styles");
var useStyles = (0, styles_1.makeStyles)({
    video: {
        width: '100%',
        height: '100%',
        objectFit: 'fill'
        // position: 'absolute'
    }
});
var VideoWidget = function (_a) {
    var videoProps = _a.videoProps;
    var src = videoProps.src, autoplay = videoProps.autoplay, muted = videoProps.muted, loop = videoProps.loop;
    var classes = useStyles();
    return (react_1.default.createElement("video", { crossOrigin: 'anonymous', src: src, muted: muted, className: classes.video, autoPlay: autoplay, loop: loop, controls: false, playsInline: true }));
};
VideoWidget.displayName = 'VideoWidget';
exports.default = VideoWidget;
//# sourceMappingURL=VideoWidget.js.map